module.exports = __webpack_public_path__ + "static/media/live_classes.cd8f71c7.png";